import api from './index'

import request from '@/utils/request'

// 查询并退款（支持php和java双平台）
export function ApiCustomerAutoRefund(data) {
  return request({
    url: api.CustomerAutoRefund,
    method: 'post',
    data: data,
    hideloading: true
  })
}